import { NotificacionUpdate } from "./NotificacionUpdate";
import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink,
  useNavigate,
  useLocation 
} from "react-router-dom";
import { Resizable } from 're-resizable';

import { useState, useEffect } from "react";

import {ReactComponent as Logo } from '../img/logo.svg';
import * as API from "../services/notificaciones";

import Navigation from '../components/Navigation';

import { FormatDate } from "../components/documentacion/FormatDate";


export function NotificacionesList(props) {
  const [notificaciones, setNotificaciones] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    API.getAllNotificationsByUser(props.especialistaId)
      .then(setNotificaciones)
      .catch(console.log);
  }, [props.especialistaId]);

  const clicNotificacion = async (e, notificacionId, notiUrl) => {
    e.preventDefault();
    try {
      // Marcar la notificación como leída
      await NotificacionUpdate(notificacionId, true);

      if (notiUrl) {
        navigate(`../${notiUrl}`);
      } else {
        window.location.reload();
      }

    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Resizable 
        id="sidebar"
        defaultSize={{
          width: 130,
        }}
        minHeight="100vh"
        maxHeight="100vh"
      >
        <div className="logo"><Logo /></div>
      </Resizable>
      <main id="main">
        <Navigation {...props} />
        <div id="detail">
          <div id='content' className="notificaciones-list">
            <h3>Notificaciones</h3>
            {notificaciones?.length ? (
              <ul className='notificaciones cpt-list'>
                {notificaciones.map((notificacion) => (
                  <li key={notificacion.id} className={notificacion.meta?.notiRead ? '' : 'unread'}>
                    {notificacion.meta?.notiRead && !notificacion.meta?.notiUrl ? (
                        <span style={{ whiteSpace: 'pre-wrap', userSelect: 'text' }}>
                            {notificacion.meta?.notiText}
                        </span>
                    ) : (
                        <a 
                            href="#" 
                            onClick={(e) => clicNotificacion(e, notificacion.id, notificacion.meta?.notiUrl)} 
                            style={{ whiteSpace: 'pre-wrap', userSelect: 'text' }}
                        >
                            {notificacion.meta?.notiText}
                        </a>
                    )}
                </li>
                ))}
              </ul>
            ) : (
              <p>Sin notificaciones</p>
            )}
          </div>
        </div>
      </main>
    </>
  );
}


export function NotificacionesPaciente(props) {
  const [notificaciones, setNotificaciones] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    API.getAllNotificationsByUser(props.especialistaId)
      .then(setNotificaciones)
      .catch(console.log);
  }, [props.especialistaId]);

  const clicNotificacion = async (e, notificacionId, notiUrl) => {
    e.preventDefault();
    try {
      // Marcar la notificación como leída
      await NotificacionUpdate(notificacionId, true);

      if (notiUrl) {
        navigate(`../${notiUrl}`);
      } else {
        window.location.reload();
      }

    } catch (error) {
      console.error(error);
    }
  };

  return (


          <div id='content' className="notificaciones-list">
            <h3>Notificaciones</h3>
            {notificaciones?.length ? (
              <ul className='notificaciones cpt-list'>
                {notificaciones.map((notificacion) => (
                  <li key={notificacion.id} className={notificacion.meta?.notiRead ? '' : 'unread'}>
                    {notificacion.meta?.notiRead && !notificacion.meta?.notiUrl ? (
                        <span style={{ whiteSpace: 'pre-wrap', userSelect: 'text' }}>
                            {notificacion.meta?.notiText}
                        </span>
                    ) : (
                        <a 
                            href="#" 
                            onClick={(e) => clicNotificacion(e, notificacion.id, notificacion.meta?.notiUrl)} 
                            style={{ whiteSpace: 'pre-wrap', userSelect: 'text' }}
                        >
                            {notificacion.meta?.notiText}
                        </a>
                    )}
                </li>
                ))}
              </ul>
            ) : (
              <p>Sin notificaciones</p>
            )}
          </div>

  );
}

